var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SimplePage',{staticClass:"simple-page-norm"},[_c('template',{slot:"header"},[_c('div',{staticClass:"labels"},[_c('div',{staticClass:"label active"},[_vm._v(_vm._s(_vm.title))])])]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }